import { SvgIcon, SvgIconProps } from '@mui/material';

const ExpandtoRightOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="ExpandtoRightOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13C3.55228 13 4 12.5523 4 12V4H20V20H12C11.4477 20 11 20.4477 11 21C11 21.5523 11.4477 22 12 22H21C21.2652 22 21.5195 21.8946 21.707 21.707C21.8946 21.5195 22 21.2652 22 21V3C22 2.44772 21.5523 2 21 2H3Z" />
      <path d="M3 15C2.44772 15 2 15.4477 2 16V21C2 21.5523 2.44772 22 3 22H8C8.26522 22 8.5195 21.8946 8.70703 21.707C8.89457 21.5195 9 21.2652 9 21V16C9 15.4477 8.55228 15 8 15H3Z" />
      <path d="M12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8H14.5859L9.99609 12.5898C9.60557 12.9804 9.60557 13.6134 9.99609 14.0039C10.3866 14.3944 11.0196 14.3944 11.4102 14.0039L16 9.41406V12C16 12.5523 16.4477 13 17 13C17.5523 13 18 12.5523 18 12V7C18 6.44772 17.5523 6 17 6H12Z" />
    </SvgIcon>
  );
};

export default ExpandtoRightOutlined;
